import { v4 as uuid } from 'uuid'

import invoiceStatus, {
  checkPaidInvoiceStatus,
  checkAdvancedState,
} from '../constants/invoiceStateEnum'

const EventTypeEnum = {
  invoiceIssued: 'invoiceIssued',
  invoiceRequested: 'invoiceRequested',
  invoiceApproved: 'invoiceApproved',
  invoiceAdvanced: 'invoiceAdvanced',
  collectionReceived: 'collectionReceived',
  invoiceSettled: 'invoiceSettled',
  remainingBalance: 'remainingBalance',
  invoiceRemainingBalancePaid: 'invoiceRemainingBalancePaid',
  costAtRepayment: 'costAtRepayment',
  adjustedFees: 'adjustedFees',
}

const DEFAULT_CURRENCY = 'USD'

const entriesSubTypes = {
  Advance: createSubTypeAdvanceEvent,
  Collection: createSubTypeCollectionEvent,
  Settlement: createSubTypeSettlementEvent,
}

export default function (props, entries) {
  const modifiedProps = { ...props }

  modifiedProps.events = []
  let events = []

  const state = props.tabName

  events.push(createInvoiceIssuedEvent(props))

  if (!checkAdvancedState(state)) {
    let newEvents = Object.keys(entriesSubTypes)
      .map((subType) => {
        return entries
          .filter((e) => e.subType === subType)
          .map((entry) => entriesSubTypes[subType](modifiedProps, entry))
      })
      .filter((arr) => !!arr.length)
      .reduce((accum, curr) => [...accum, ...curr], [])

    events = [...events, ...newEvents]
  } else {
    events = [...events, createSubTypeAdvanceUnpaidEvent(modifiedProps, state)]
  }

  if (state !== invoiceStatus.SETTLEMENT_COMPLETED) {
    events = events.concat(createInvoicePaidEvent(modifiedProps))
  }

  events = [...events, createInvoiceCostAtRepaymentEvent(modifiedProps)]

  if (modifiedProps.lateFees !== 0) {
    const adjustedFeesDate = checkPaidInvoiceStatus(state)
      ? modifiedProps.paidAt
      : new Date()

    events = [
      ...events,
      createInvoiceAdjustedFeesEvent(modifiedProps, adjustedFeesDate),
    ]
  }

  modifiedProps.events = events

  return modifiedProps
}

const commonData = (data) => ({
  id: uuid(),
  date: new Date().toString(),
  currency: data.currency || DEFAULT_CURRENCY,
})

function createInvoiceIssuedEvent(data) {
  return {
    ...commonData(data),
    date: data.issuedDate,
    type: EventTypeEnum.invoiceIssued,
    amount: data.invoiceAmount,
    invoiceId: data.id,
  }
}

function createSubTypeAdvanceEvent(data, entry) {
  return {
    ...commonData(data),
    date: entry.Date,
    type: EventTypeEnum.invoiceAdvanced,
    amount: entry.directional_direction,
    invoiceId: data.id,
  }
}

function createSubTypeAdvanceUnpaidEvent(data, state) {
  return {
    ...commonData(data),
    date: data.requestedAt,
    type:
      state === 'requested' || state === 'pendingReview'
        ? EventTypeEnum.invoiceRequested
        : EventTypeEnum.invoiceApproved,
    amount: data.effectiveOrAdvanceAmount,
    invoiceId: data.id,
  }
}

function createSubTypeCollectionEvent(data, entry) {
  return {
    ...commonData(data),
    date: entry.Date,
    type: EventTypeEnum.collectionReceived,
    amount: entry.directional_direction,
    invoiceId: data.id,
  }
}

function createSubTypeSettlementEvent(data, entry) {
  return {
    ...commonData(data),
    date: entry.Date,
    type: EventTypeEnum.invoiceSettled,
    amount: entry.directional_direction,
    paymentId: entry.reference,
    invoiceId: data.id,
  }
}

function createInvoicePaidEvent(data) {
  return {
    ...commonData(data),
    type: EventTypeEnum.remainingBalance,
    amount: data.remainingBalance,
    invoiceId: data.id,
  }
}

function createInvoiceCostAtRepaymentEvent(data) {
  return {
    ...commonData(data),
    date: data.dueDate,
    type: EventTypeEnum.costAtRepayment,
    amount: data.feeAtDue,
    invoiceId: data.id,
  }
}

function createInvoiceAdjustedFeesEvent(data, adjustedFeesDate) {
  return {
    ...commonData(data),
    date: adjustedFeesDate.toString(),
    type: EventTypeEnum.adjustedFees,
    amount: data.lateFees,
    invoiceId: data.id,
    lateFees: data.lateFees,
  }
}
